export enum NotificationMessage {
    SUCCESS = "Updated successfully",
    ARCHIVE_SUCCESS = "Deleted successfully",
    ERROR = "An unknown error occurred",
    REMOVE_SUCCESS = "Removed successfully",
}
